module.exports = __webpack_public_path__ + "static/ilustracao-integracao-farmacias-bb72474f39fb98025d624c58bffa2f6e.svg";